import { BREAKPOINT_SIZES } from '@consts/index'
import { objectKeys } from '@helpers/utils'
import useWindowSize from './useWindowSize'

export { default as useExiting } from './useExiting'
export { default as useIdle } from './useIdle'
export { default as useMediaQuery } from './useMediaQuery'

export function useViewportDimensions() {
  const windowSize = useWindowSize()
  const breakpoint = objectKeys(BREAKPOINT_SIZES).find(
    key => (windowSize.width || 0) < BREAKPOINT_SIZES[key]
  )
  return { breakpoint }
}
